import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex: 1;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  padding: 16px 24px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { List } from "antd";
// import { FlatList as RNFlatList } from 'react-native-gesture-handler'
// import Animated from 'react-native-reanimated'
import { reaction, toJS } from "mobx";
import { Text } from "./Text";
import { View } from "./View";
import { ActivityIndicator } from "./ActivityIndicator";
import { useStyledTheme } from "@/hooks/useStyledTheme";
const FlatListLoadingWrapper = styled(View).withConfig({
    componentId: "sc-f65b68e6-0"
})(_templateObject());
export const DefaultEmptyComponent = (param)=>{
    let {} = param;
    const theme = useStyledTheme();
    return /*#__PURE__*/ _jsx(View, {
        style: {
            flex: 1,
            alignContent: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ _jsx(Text, {
            style: {
                flex: 0,
                textAlign: "center"
            },
            children: "데이터가 없습니다."
        })
    });
};
export const DefaultLoadingComponent = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsxs(FlatListLoadingWrapper, {
        children: [
            /*#__PURE__*/ _jsx(ActivityIndicator, {
                color: "#000"
            }),
            children
        ]
    });
};
const ListWrapper = styled(View).withConfig({
    componentId: "sc-f65b68e6-1"
})(_templateObject1());
export const FlatList = (param)=>{
    let { status , actions , renderItem , ListHeaderComponent , ListFooterComponent , useRefresh =true , ListEmptyComponent =DefaultEmptyComponent , ListLoadingComponent =DefaultLoadingComponent , // contentContainerStyle,
    // onScroll,
    contentOffset  } = param;
    const [visible, setVisible] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [refreshing, setRefreshing] = useState(false);
    const [addingItems, setAddingItems] = useState(false);
    useEffect(()=>{
        const loadingReaction = reaction(()=>status.loading, (value, dispose)=>{
            setVisible(!value);
        });
        const refreshingReaction = reaction(()=>status.refreshing, (value)=>{
            setRefreshing(value);
        });
        const addingItemsReaction = reaction(()=>status.addingItems, (value)=>{
            setAddingItems(value);
        });
        const dataSourceReaction = reaction(()=>actions.items, (data)=>{
            const list = toJS(data);
            setDataSource(list);
        });
        return ()=>{
            loadingReaction();
            refreshingReaction();
            addingItemsReaction();
            dataSourceReaction();
        };
    }, []);
    if (!visible) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: ListLoadingComponent
        });
    }
    return /*#__PURE__*/ _jsx(ListWrapper, {
        children: /*#__PURE__*/ _jsx(List, {
            itemLayout: "horizontal",
            dataSource: dataSource,
            renderItem: renderItem
        })
    });
};
const FlatListFooterWrapper = styled(View).withConfig({
    componentId: "sc-f65b68e6-2"
})(_templateObject2());
export const FlatListDefaultFooter = ()=>{
    return /*#__PURE__*/ _jsx(FlatListFooterWrapper, {
        children: /*#__PURE__*/ _jsx(ActivityIndicator, {
            color: "#000"
        })
    });
};
